import Vue from "vue"
// const API_BASE_URI = "http://120.78.231.126"
const API_BASE_URI = "http://www.gdzjhg.com"
// const API_BASE_URI = "http://192.168.0.41:9393"
// const API_BASE_URI = "";
// const API_BASE_URI = "http://192.168.3.178:8080"
Vue.prototype.$httpUrl = API_BASE_URI
var config = {
  API_BASE_URI: API_BASE_URI
}

Array.prototype.myfilter = function (fun /*, thisp*/) {
  var len = this.length
  if (typeof fun != "function") {
    throw new TypeError()
  }
  var res = new Array()
  var thisp = arguments[1]
  for (var i = 0; i < len; i++) {
    if (i in this) {
      var val = this[i] // in case fun mutates this
      if (fun.call(thisp, val, i, this)) {
        res.push(val)
      }
    }
  }
  return res
}
export default config
